import axios, { HttpStatusCode } from "axios";
import { StatusMessageResponse } from "../../../common/interfaces/status-message-response";

export async function deleteAllRequistions(data: Array<any>, token: string): Promise<StatusMessageResponse> {
    try {
      const response = await axios.delete(process.env.REACT_APP_BASE_URL+'/requisicao/all/ids/', 
        {
          data,
          headers: {
            Authorization: 'Bearer ' + token
          }
        }
      );
  
      const res = response.data; // Supondo que a resposta de criação seja retornado pelo backend
      return res;
    } catch (error) {
      return {
      statusCode: HttpStatusCode.InternalServerError,
      message: 'Falha ao deletar as requisição',
    }
    }
}

export async function deleteRequistion(id: string, token: string): Promise<StatusMessageResponse> {
  try {
    const response = await axios.delete(process.env.REACT_APP_BASE_URL+'/requisicao/'+id, 
      {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
    );

    const res = response.data; // Supondo que a resposta de criação seja retornado pelo backend
    return res;
  } catch (error) {
    return {
      statusCode: HttpStatusCode.InternalServerError,
      message: 'Falha ao deletar de uma requisição',
    }
  }
}